<template>
  <!--
    Режим корректировки
    Рисуем редактор
	-->
  <div v-if="editorMode" class="outer-container-fluid">
    <div class="row my-0" style="height: 100%;" align="stretch">
      <Split style="flex-basis: 0; border-radius: 5px;"
        class="flex-grow-1 overflow-hidden white d-flex"
        :gutter-size="4"
        direction="horizontal">
      <!-- окно редактора -->
        <SplitArea class="d-flex flex-column" :size="pagePlayerSize">
          <!-- widgets breadcrumbs -->
          <div v-if="listOfParentsSelectedWidget.length > 0">
            <ul class="breadcrumb">
              <li
                :class="[{
                  'widgets-breadcrumbs-item': listOfParentsSelectedWidget[index].$ID === listOfParentsSelectedWidget.at(-1).$ID &&
                  listOfParentsSelectedWidget[index].$Type === listOfParentsSelectedWidget.at(-1).$Type
                }]"
                v-for="(item, index) in listOfParentsSelectedWidget"
                :key="item.$ID"
                @click="onSelectWidgetFromBreadcrumbs(item, index)"
              >
                <span>
                  {{listOfTitlesBreadcrumbsWidgets[item.$Type]}}
                </span>
              </li>
            </ul>
          </div>
          <div class="col editor-canvas">
            <component
              v-if="localValue"
              :readonly='isReadOnly()'
              :is="localValue.$Type"
              :model="localValue"
              :class="[{'spilka-ui-kit-dr-page-player': currentUIKit === 'spilkaUIKit'}]"
              @modelChanged="$emit('input', $event)"
            />
          </div>
        </SplitArea>
        <!-- Панель свойств и компонентов -->
        <SplitArea class="d-flex flex-column" :size="propPanelSize">
          <div class="row my-0" style="height: 100%; display: block;" align="stretch" v-if="!autoHide">
            <div class="col-12  editor-panel" style="height: 100%;" align="stretch">
              <dr-designer-panel @changeTab="changeTab" :items="items" v-model="selectedWidget" :contract="selectedWidgetDataContract" :readonly='readonly' @changeAutoHide="changeAutoHide" :tab="tab" :autoHide="autoHide"></dr-designer-panel>
            </div>
          </div>
        </SplitArea>

      </Split>
      <div v-if="autoHide">
        <div class="dr-designer-panel-auto-hide-container"></div>
        <dr-designer-panel @changeTab="changeTab" v-if="openPanel" class="dr-designer-panel-auto-hide-mode" v-model="selectedWidget" :contract="selectedWidgetDataContract" :readonly='readonly' @changeAutoHide="changeAutoHide" :tab="tab" :autoHide="autoHide"></dr-designer-panel>
        <div class="panel-item-container" v-if="autoHide">
          <div v-for="(item, index) in items" :key="index" class="panel-item mt-2 ml-1 prop-panel-btn-tabs" @click="changeTab(item.value)">{{item.name}}</div>
        </div>
      </div>
    </div>
  </div>
  <!--
    Режим просмотра(проигрывания)
    Рисуем только проигрыватель
	-->
  <component v-else
    :is="localValue.$Type"
    :model="localValue"
    @close-dialog="$emit('close-dialog')" />
</template>

<script>
import { EventBus } from '../index'
import moduleMixin from '../mixins/changedModel-mixin'
import propertyPanelMixin from '../mixins/propertyPanel-mixin'
import { componentsModels } from '../widgets'
import { WidgetsHelper } from '@it-enterprise/web-app-common/src/tools/WidgetsHelper'

const onKeyUpDeleteWidgetEvent = new CustomEvent('onKeyUpDeleteWidgetEvent', { bubbles: true, cancelable: true })

const propPanelSizeClose = 0
const propPanelSizeDefault = 20

const pagePlayerSizeFull = 100
const pagePlayerSizeDefault = 80

const listClassesOutsidEelements = [
  'editor-canvas',
  'web-app-modeler-app-bar',
  'split-item-for-pages',
  'v-navigation-drawer',
  'container-pin-navigation-items',
  'hidden-spliter-line'
]

export default {
  mixins: [moduleMixin, propertyPanelMixin],
  props: {
    id: {
      type: String,
      required: true
    },
    editorMode: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: { required: true },
    snippets: {
      type: Array,
      default: () => []
    },
    isSnippetEditor: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    autoHide: false,
    openPanel: false,
    tab: 0,
    propPanelSize: 20, // размер панели свойств
    pagePlayerSize: 80 // размер page player
  }),
  provide: function() {
    return {
      stateName: this.stateName
    }
  },
  watch: {
    snippets: function(value) {
      if (this.editorMode) {
        this.$store.commit(`${this.stateName}/setSnippets`, value)
      }
    }
  },
  computed: {
    widgetsHelper() {
      return new WidgetsHelper(this.stateName, this.$store)
    },
    currentUIKit() {
      return this.$store.getters.currentUIKit
    },
    listOfTitlesBreadcrumbsWidgets() {
      let value = {}

      this.listOfParentsSelectedWidget.forEach(widget => {
        const index = componentsModels.findIndex(component => widget.$Type === component.$Type)
        
        if (index !== -1) {
          value[widget.$Type] = componentsModels[index].name
        }
      })
      return value
    },
    listOfParentsSelectedWidget() {
      return this.$store.getters[`${this.stateName}/listOfParentsSelectedWidget`]
    },
    stateName() {
      return `drdrawer_${this.id}`
    },
    selectedWidget: {
      get() {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.openPanel = false
        return this.$store.state[this.stateName].selectedWidget
      },
      set(val) {
        this.$store.commit(`${this.stateName}/setSelectedWidgetProperties`, val)
        this.$emit('input')
      }
    },
    selectedWidgetDataContract() {
      return this.$store.state[this.stateName].selectedWidgetDataContract
    },
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.widgetsHelper.setSelectedWidget(undefined)
        this.$emit('input', value)
      }
    }
  },
  methods: {
    onSelectWidgetFromBreadcrumbs(selectedWidget) {
      //Если кликаем на последний виджет в breadcrumbs - не делать лишних действий
      if (this.listOfParentsSelectedWidget.at(-1).$ID === selectedWidget.$ID) {
        return
      }

      const onSetSelectedWidgetFromBreadCrumb = new CustomEvent('onSetSelectedWidget', {
        bubbles: true,
        cancelable: true,
        detail: { widgetId: selectedWidget.$ID }
      })

      document.body.dispatchEvent(onSetSelectedWidgetFromBreadCrumb)
    },
    // Обработка клика вне элемента
    outsideClick(event) {
      if (!this.autoHide) {
        return
      }
      for (let i = 0; i < listClassesOutsidEelements.length; i++) {
        let outsideElement = window.document.getElementsByClassName(listClassesOutsidEelements[i])[0]
        if (!outsideElement) {
          continue
        }
        if (outsideElement.contains(event.target)) {
          this.openPanel = false
        }
      }
    },

    changeAutoHide(value) {
      this.autoHide = value
      if (this.autoHide) {
        this.propPanelSize = propPanelSizeClose
        this.pagePlayerSize = pagePlayerSizeFull
        return
      }
      this.propPanelSize = propPanelSizeDefault
      this.pagePlayerSize = pagePlayerSizeDefault
    },
    changeTab(value) {
      this.tab = value
      if (this.autoHide) {
        this.openPanel = true
      }
    },
    // Is page or snippet is custom
    isUserItem(id) {
      let module = this.$store.state.appModels?.changedModel?.Modules?.[this.module]

      let userItem = module?.Pages?.find(page => page.$ID === id)
      if (userItem) {
        return true
      }
      // УВАГА, коли логіку отримання сніппіти перероблять на id - потрібно буде видалити сроку нижчі, та шукати сніппіт по id
      let snippetName = this.$route.params?.snippetName
      if (!snippetName) {
        return false
      }
      userItem = module?.Snippets?.find(snippet => snippet.Name === snippetName)
      if (userItem) {
        return true
      }

      return false
    },
    isReadOnly() {
      if (!this.readonly) {
        return false
      }
      let isUserItem = this.isUserItem(this.localValue.$ID)
      if (this.readonly && isUserItem) {
        return false
      }
      return true
    },
    createKeyUpEvent(event) {
      if (event.ctrlKey || event.altKey || event.shiftKey) {
        return
      }

      //Если мы что-то правим в input, delete не должен сработать
      if (event.target.localName === 'input') {
        return
      }

      //Проверка на клавишу backspace и delete
      if (event.keyCode === 46) {
        document.body.dispatchEvent(onKeyUpDeleteWidgetEvent)
      }
    }
  },
  beforeDestroy() {
    if (this.editorMode) {
      window.document.body.removeEventListener('click', this.outsideClick)
      window.document.body.removeEventListener('keyup', this.createKeyUpEvent)
    }
  },
  created() {
    if (this.editorMode) {
      window.document.body.addEventListener('click', this.outsideClick)
      EventBus.$on('createSnippet', payload => this.$emit('createSnippet', payload))

      //create keyUp event
      window.document.body.addEventListener('keyup', this.createKeyUpEvent)
    }

    let vm = this
    if (this.$store.state[this.stateName] !== undefined) {
      //eslint-disable-next-line
      console.log(`module "${this.stateName}" unregistered`)
      this.$store.unregisterModule(this.stateName)
    }

    // регистрация служебного модуля vuex для этого проигрывателя
    this.$store.registerModule(this.stateName, {
      namespaced: true,
      state: {
        isEditorMode: this.editorMode,
        isSnippetEditor: this.isSnippetEditor,
        selectedWidget: undefined,
        parentsCurrentWidget: [],
        selectedWidgetDataContract: '',
        snippets: this.snippets,
        isContextMenuVisible: false
      },
      getters: {
        pageModel() {
          return vm.value.$Type == 'dr-page' ? vm.value : undefined
        },
        listOfParentsSelectedWidget(state) {
          return state.parentsCurrentWidget
        }
      },
      mutations: {
        setParentsCurrentWidget(state, listOfParentsWidgets) {
          state.parentsCurrentWidget = listOfParentsWidgets
        },
        setSelectedWidget(state, { widget, contract }) {
          state.selectedWidget = widget
          state.selectedWidgetDataContract = contract
        },
        setSelectedWidgetProperties(state, widgetProps) {
          for (let prop in widgetProps) {
            state.selectedWidget[prop] = widgetProps[prop]
          }
        },
        setIsContextMenuVisible(state, value) {
          state.isContextMenuVisible = value
        },
        setSnippets(state, value) {
          state.snippets = value
        }
      }
    })
  }
}
</script>

<style lang="scss">
.editor-panel {
  height: 100%;
  overflow: auto;
  border-left: 1px solid #d3d3d3;
  flex: 0 0 300px !important;
  padding: 0 !important;
}
.editor-canvas {
  height: 100%;
  overflow: auto;
}

.draggable-target {
  height: 100%;
  min-height: 50px;
  padding: 5px;
}
.container {
  width: 100%;
  padding: 12px;
  margin-right: auto;
  margin-left: auto;
}
.container-fluid {
  @extend .container !optional;
  max-width: 100%;
}
.outer-container-fluid {
  @extend .container-fluid !optional;
  height: 100%;
}
.row {
  margin-left: -12px;
  margin-right: -12px;
}
.col.editor-canvas {
  padding: 0px 12px 12px 12px;
}
.panel-item {
  max-width: 35px;
  background-color: #673ab7;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  color: white;
  padding: 10px 5px;
  cursor: pointer;
  border-radius: 3px;
}
.panel-item-container {
  height: 100%;
  width: 35px;
  display: flex;
  flex-direction: column;
}

.dr-designer-panel-auto-hide-mode {
  position: fixed;
  right: 35px;
  z-index: 2;
  background-color: white;
  max-width: 350px;
  width: 350px;
  box-shadow: rgba(0, 0, 0, 0.06) -8px 0px 4px -1px;
  padding-bottom: 48px;
}

.dr-designer-panel-auto-hide-container {
  height: 100%;
  width: 10px;
  position: fixed;
  right: 30px;
  background: white;
}

.breadcrumb { 
  list-style: none; 
  overflow: hidden; 
  font: 15px Sans-Serif;
  padding: 0 !important;
}
.breadcrumb li { 
  float: left; 
  z-index: 2;
  cursor: pointer;
  background: #f3f3f4; 
  border: 1px 0 1px 0 solid #f3f3ea;
  :hover {
    color: #fff;
    background: #0098ec;
  }
  span:hover:after {
    border-left: 12px solid #0098ec;
  }
}
.breadcrumb li span {
  color: #868686;
  text-decoration: none; 
  padding: 4px 12px 5px 24px;
  position: relative; 
  display: block;
  float: left;
}

.breadcrumb li span::after { 
    content: " ";
    display: block;
    width: 0;
    height: 0;
    border-top: 13px solid transparent;
    border-bottom: 14px solid transparent;
    border-left: 12px solid #f3f3f4;
    position: absolute;
    top: 22px;
    margin-top: -22px;
    left: 100%;
    z-index: 1;
}

.widgets-breadcrumbs-item {
  background: #0098ec !important;
  span {
    color: #fff !important;
  }
  ::after {
    border-left: 12px solid #0098ec !important;
  }
}

.spilka-ui-kit-dr-page-player {
  @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap');

  * {
    font-family: 'IBM Plex Sans', sans-serif !important;
  }
}

@media screen and(max-width: 600px)  {
    .hide-on-mobile {
      display: none !important;
    }
}

@media screen and(min-width: 600px) and(max-width: 1264px) {
    .hide-on-tablet {
      display: none !important;
    }
}

@media screen and(min-width: 1264px) {
    .hide-on-pc {
      display: none !important;
    }
}
</style>
